import {Component, OnDestroy, OnInit} from '@angular/core';
import {ArticleModel} from '../../common/core/services/faq';
import {CategorieService} from '../../common/core/services/faq';
import {CategorieModel} from '../../common/core/services/faq';
import {StatsService} from '../../common/core/services/faq';

@Component({
  selector: 'app-faq-statistiques',
  templateUrl: './statistiques.component.html',
  styleUrls: ['./statistiques.component.css'],
})
export class StatistiquesComponent implements OnInit {
  public plusVues: Array<ArticleModel>;
  public mieuxNotes: Array<ArticleModel>;
  public plusCommentes: Array<ArticleModel>;
  public categories: Array<CategorieModel>;
  public nextUrl: string;
  public plusVuesNextUrl: string;
  public mieuxNotesNextUrl: string;
  public plusCommentesNextUrl: string;
  public prevUrl: string;
  public plusVuesPrevUrl: string;
  public mieuxNotesPrevUrl: string;
  public plusCommentesPrevUrl: string;
  public nbElements: number;
  public plusVuesNbElements: number;
  public mieuxNotesNbElements: number;
  public plusCommentesNbElements: number;
  public page: number;
  public plusVuesPage: number;
  public mieuxNotesPage: number;
  public plusCommentesPage: number;
  public limit: number;

  // dataSource: ExampleDataSource | null;
  // constructor(private cs: CategorieService, private as: ArticleService) {}
  constructor(private cs: CategorieService, private as: StatsService) {}

  ngOnInit() {
      this.limit = 10;
      this.categories = null;
      this.mieuxNotes = null;
      this.plusVues = null;
      this.plusCommentes = null;

      this.as.listByOrder('vues', 'DESC', this.limit).subscribe(
        data => {
          this.plusVues = data['results'];
          this.plusVuesNbElements = data['count'];
          this.plusVuesNextUrl = data['next'];
          this.plusVuesPrevUrl = data['previous'];
          this.plusVuesPage = 1;
        }
      );
      this.as.listByOrder('commentaires', 'DESC', this.limit).subscribe(
        data => {
          this.plusCommentes = data['results'];
          this.plusCommentesNbElements = data['count'];
          this.plusCommentesNextUrl = data['next'];
          this.plusCommentesPrevUrl = data['previous'];
          this.plusCommentesPage = 1;
        }
      );
      this.as.listByOrder('note_moyenne', 'DESC', this.limit).subscribe(
        data => {
          this.mieuxNotes = data['results'];
          this.mieuxNotesNbElements = data['count'];
          this.mieuxNotesNextUrl = data['next'];
          this.mieuxNotesPrevUrl = data['previous'];
          this.mieuxNotesPage = 1;
        }
      );
      this.cs.list(0, this.limit, null, '-nb_articles').subscribe(
        data => {
          this.categories = data['results'];
          this.nbElements = data['count'];
          this.nextUrl = data['next'];
          this.prevUrl = data['previous'];
          this.page = 1;
        }
      );
  }

  reloadCategories(url, type): void {
    if (url) {
      this.cs.reload(url)
        .subscribe(data => {
          this.categories = data['results'];
          this.nbElements = data['count'];
          this.nextUrl = data['next'];
          this.prevUrl = data['previous'];
          if (type === 'prev') {
            this.page--;
          } else {
            this.page++;
          }
        });
    }
  }

  reloadArticles(url, type, name): void {
    if (url) {
      this.as.reload(url)
        .subscribe(data2 => {
          this[name] = data2['results'];
          this[name + 'NbElements'] = data2['count'];
          this[name + 'NextUrl'] = data2['next'];
          this[name + 'PrevUrl'] = data2['previous'];
          if (type === 'prev') {
            this.page--;
          } else {
            this.page++;
          }
        });
    }
  }
}
// export class ExampleDataSource extends DataSource<ArticleModel[]> {
//   constructor(private _statistiquesComponent: StatistiquesComponent) {
//     super();
//   }
//
//   connect(): Array<ArticleModel> {
//     return this._statistiquesComponent.plusVues;
//   }
//
//   disconnect() {}
// }
